<app-in-app-navbar></app-in-app-navbar>
<div class="d-flex">
    <app-in-app-sidebar></app-in-app-sidebar>
    <div class="page-content">
        <div style="flex-grow: 1;" [@routeAnimations]="PrepareRoute(outlet)">
            <router-outlet #outlet="outlet"></router-outlet>
        </div>
    </div>